export class StorageUtil {
	isJsonString(str: string) {
		try {
			JSON.parse(str);
		} catch (e) {
			return false;
		}
		return true;
	}

	setStorage(name: string, data: string) {
		if (typeof data === "object") data = JSON.stringify(data);
		localStorage.setItem(name, data);
	}

	getStorage(name: string) {
		if (typeof window !== "undefined" && process.client) {
			const data = localStorage.getItem(name);
			if (data) {
				return this.isJsonString(data) ? JSON.parse(data || "[]") : data;
			} else {
				return null;
			}
		}
	}
}
